import { LogLevel } from '$lib/domains/shared/logger/log-level';
import { Namespace } from '$lib/domains/shared/logger/namespace';
import { prettyLog } from '$lib/domains/shared/logger/pretty-log';

export class Logger {
  private readonly _namespace: Namespace;
  private readonly _logLevel: LogLevel;

  constructor(
    private readonly isDev: boolean,
    namespace: string,
    logLevel: LogLevel,
  ) {
    this._namespace = new Namespace(namespace);
    this._logLevel = logLevel;
  }

  error(message: unknown, ...args: unknown[]): void {
    this._log(LogLevel.ERROR, message, ...args);
  }

  info(message: unknown, ...args: unknown[]): void {
    this._log(LogLevel.INFO, message, ...args);
  }

  debug(message: unknown, ...args: unknown[]): void {
    this._log(LogLevel.DEBUG, message, ...args);
  }

  warn(message: unknown, ...args: unknown[]): void {
    this._log(LogLevel.WARN, message, ...args);
  }

  private _log(level: LogLevel, message: unknown, ...args: unknown[]): void {
    const loggerEnabled =
      typeof localStorage !== 'undefined'
        ? localStorage.getItem('logger_enabled')
        : null;

    if (!this.isDev && !loggerEnabled) {
      return;
    }

    if (this._logLevel > level) {
      return;
    }

    prettyLog(level, this._namespace, message, ...args);
  }
}
